import React, { Component, Fragment } from 'react'
import classnames from 'classnames'
import * as api from '../../../api'
import UserBar from '../../common/user-bar/user-bar'

const scope = 'SettingsPage'

const preferenceDescs = {
  showStream: 'Show my stream on the main page',
}

class SettingsPage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
    }
    this.logOut = this.logOut.bind(this)
  }

  componentDidMount() {
    this.getUserData()
  }

  getUserData() {
    api
      .getPreferences()
      .then(preferences => {
        this.setState({
          loading: false,
          preferences,
        })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  setPreferences(prefs) {
    api
      .setPreferences(prefs)
      .then(preferences => {
        this.setState({
          loading: false,
          preferences,
        })
      })
      .catch(() => {
        this.setState({ loading: false })
      })
  }

  logOut() {
    api.logOut().then(this.setState({ user: null }))
  }

  render() {
    const { className, user } = this.props
    const { loading, preferences } = this.state

    const Checkbox = ({ pref, onClick }) => {
      const value = !!preferences[pref]
      return (
        <a className={classnames(`${scope}-Checkbox`, value && `${scope}-Checkbox_Checked`)} {...{ onClick }}>
          <div>
            <i className={`fa fa-${value ? 'check' : 'times'}`} /> {preferenceDescs[pref]}
          </div>
        </a>
      )
    }

    return (
      <div className={classnames(scope, className)}>
        <div className={classnames(`${scope}-Header`)}>
          <UserBar user={user} onLogOut={this.logOut} />
        </div>
        <div className={classnames(`${scope}-Content`)}>
          {!loading && (
            <Fragment>
              <h2>Account Settings</h2>
              <Checkbox
                pref='showStream'
                onClick={() => this.setPreferences({ ...preferences, showStream: !preferences.showStream ? 1 : 0 })}
              />
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default SettingsPage



// WEBPACK FOOTER //
// ./src/components/views/settings-page/settings-page.jsx